import { checkParams, zeroUnit, soFarDate } from '../../utils'
import { formatTime, formatDate, formatDatetime } from '../../filter'

function isTargetPassenger(accidentInfo) {
	// 是否为标的车乘客
	return (
		accidentInfo &&
		accidentInfo.injuryType === '02' &&
		accidentInfo.position === '02'
	)
}

export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, injured, setting } = this
	let isPAIC = this.isPAIC && this.isFirstVisit
	if (!isPAIC) {
		return false
	}

	let arr = []
	const accidentInfo = injured.accidentInfo || ''
	//平安车险
	if (isPAIC && this.isCarInsurance) {
		arr = arr.concat([
			{
				label: '类型',
				key: 'injuryType',
				value: accidentInfo.injuryType,
				selectOption: setting.injuryIdentityList,
				type: 'select',
				notNull: '1',
				canEdit: true,
			},
			{
				label: '出行方式',
				key: 'travelModel',
				value: accidentInfo.travelModel,
				selectOption: setting.trafficSituationList,
				type: 'select',
				notNull: '1',
				canEdit: true,
			},
			{
				label: '人员位置',
				key: 'position',
				value: accidentInfo.position,
				selectOption: setting.injuryPositionList,
				type: 'select',
				notNull: '1',
				canEdit: true,
			},
		])
		// if (
		// 	accidentInfo.injuryType === '02' &&
		// 	accidentInfo.position === '01' &&
		// 	accidentInfo.insuredRelation
		// ) {
		// 	arr.push({
		// 		label: '伤者与被保险人关系',
		// 		key: 'insuredRelation',
		// 		value:
		// 			accidentInfo.insuredRelation === '06'
		// 				? accidentInfo.otherContent
		// 				: accidentInfo.insuredRelation,
		// 		selectOption: setting.injuredRelationList,
		// 		type: 'select',
		// 		notNull: '1',
		// 		canEdit: true,
		// 		labelSpan: 10,
		// 		wrapperSpan: 14,
		// 	})
		// }
		arr.push({
			label: '伤者与被保险人关系',
			key: 'insuredRelation',
			value:
				accidentInfo.insuredRelation === '06'
					? accidentInfo.otherContent
					: accidentInfo.insuredRelation,
			selectOption: setting.injuredRelationList,
			type:
				accidentInfo.injuryType === '02' &&
				accidentInfo.travelModel === '01' &&
				accidentInfo.position === '01'
					? 'select'
					: 'hide',
			notNull: '1',
			canEdit: true,
			labelSpan: 10,
			wrapperSpan: 14,
		})
		arr = arr.concat([
			{
				label: '伤者事故责任',
				key: 'blame',
				value: accidentInfo.blame,
				selectOption: setting.blameTypeList,
				type: 'select',
				notNull: '1',
				canEdit: true,
			},
			{
				label: '是否上下班途中',
				key: 'onWay',
				value: accidentInfo.onWay,
				selectOption: setting.yesNoList,
				type: 'select',
				notNull: '1',
				canEdit: true,
			},
			{
				label: '自身有无违法行为',
				key: 'isIllegal',
				value: accidentInfo.isIllegal,
				selectOption: setting.isPeccancyList,
				type: 'select',
				notNull: '1',
				canEdit: true,
				labelSpan: 10,
				wrapperSpan: 14,
			},
			{
				label: '对方有无违法行为',
				key: 'otherIllegal',
				value: accidentInfo.otherIllegal,
				selectOption: setting.isPeccancyList,
				type: 'select',
				notNull: '1',
				canEdit: true,
				labelSpan: 10,
				wrapperSpan: 14,
			},
		])
	}

	//平安非车险
	if (isPAIC && !this.isCarInsurance) {
		arr = arr.concat([
			{
				label: '伤者事故责任',
				key: 'blame',
				value: accidentInfo.blame,
				selectOption: setting.blameTypeList,
				type: 'select',
				notNull: '1',
				canEdit: true,
			},
			{
				label: '是否上下班途中',
				key: 'onWay',
				value: accidentInfo.onWay,
				selectOption: setting.yesNoList,
				type: 'select',
				notNull: '1',
				canEdit: true,
				labelSpan: 10,
				wrapperSpan: 14,
			},
		])
	}

	const obj = {
		title: this.isCarInsurance ? '交通事故信息' : '事故信息',
		children: arr,
	}

	return obj
}
